// extracted by mini-css-extract-plugin
export default {"list":"jlHh02fF9mL8YNDHc3O9"};